import { CompositeFilterDescriptor, filterBy, FilterDescriptor } from '@progress/kendo-data-query';
import { DropDownList, DropDownListChangeEvent, DropDownListFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import useAsiteStatusesByWorkspaceNameQuery from '../hooks/useCodeTables/useAsiteStatusesByWorkspaceNameQuery';

export const StatusCell = (props: any) => {
    let workspaceName =
        typeof props.dataItem?.sourceDirectory === 'object'
            ? props.dataItem?.sourceDirectory?.workspaceName
            : props.dataItem?.sourceDirectory;

    const { data: statuses, isLoading } = useAsiteStatusesByWorkspaceNameQuery(workspaceName);
    const [data, setData] = useState<any>(statuses?.slice());

    const filterData = (filter: FilterDescriptor | CompositeFilterDescriptor) => {
        const data: any[] = statuses!.slice();
        return filterBy(data, filter);
    };

    const filterChange = (event: DropDownListFilterChangeEvent) => {
        setData(filterData(event.filter));
    };
    const handleChange = (e: DropDownListChangeEvent) => {
        if (props.onChange) {
            props.onChange({
                dataIndex: 0,
                dataItem: props.dataItem,
                field: props.field,
                syntheticEvent: e.syntheticEvent,
                value: e.target.value,
            });
        }
    };
    const { dataItem } = props;
    const field = props.field || '';
    const dataValue = dataItem[field];

    useEffect(() => {
        setData(statuses?.slice());
    }, [statuses]);

    return (
        <DropDownList
            {...props}
            data={data}
            onChange={handleChange}
            value={statuses?.find((c: any) => c?.statusId === dataValue?.statusId)}
            disabled={props.disabled || _.isEmpty(statuses)}
            onFilterChange={filterChange}
            filterable={props?.filterable ?? true}
            textField="statusName"
            dataItemKey="statusId"
            loading={isLoading}
        />
    );
};
